// extracted by css-extract-rspack-plugin
export default {"kibScope":"kibScope-yzD3yU","hideArrow":"hideArrow-ALmImD","customDropdown":"customDropdown-tkUO4k"};